import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizContainer } = framework_tool
const { isType } = utils_tool
import {WizInputNumber} from "wiz-components";
let {WizForm, WizRow,WizCol, WizIcon, WizTooltip } = component_tool;
class Editor extends WizContainer {
  componentName = 'Editor'

  constructor(props) {
    super(props)
    this.state = {
      timestamp: new Date().getTime()
    }
    
  }

  _ok = (data) => {
    let fitterValues = this.fitterFieldsValue(data);
    let path = 'interactLiveResources/add'
    if(this.props.record && this.props.record.id){
      path = 'interactLiveResources/update'
    }
    this.doAction({
      path: path,
      payload: {
        key: 'interactLiveResources@batchCreateZoomUserResources',
        apiParams: {...fitterValues,channel:2}
      }
    })
  }

  _doInitParams = ()=>{
    
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(data) {
    let fitterValues = {};
    Object.keys(data).forEach(key => {
      const value = data[key];
      if (key === 'expirationTime' && value != null && value != undefined) {
        fitterValues['expirationTime'] = value.format("YYYY-MM-DD HH:mm:ss");
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  propsAndStateOnChange = {
    save: this._saveOnChange.bind(this)
  }

  _saveOnChange(nextProps, nextState) {
    if (nextProps.save.code === 1) {
      wizNotice.success('操作成功')
      this.props.changeModal(false, true);
      let { editorSuccess } = this.props
      editorSuccess && editorSuccess()
    } else {
      wizNotice.error(nextProps.save.msg)
    }
  }

  render() {
    const { record={}} = this.props
    console.log("record==",record)
    const columns = [
      {
        name: "id",
        formItem: {
          type: 'hidden',
          initialValue: record.id
        },
      },
      {
        title: "名称",
        name: "firstName",
        dataIndex: "firstName",
        formItem: {
          initialValue:  record.firstName ,
          rules: [{ required: true, message: '请输入名称' }],
        }
      },
      {
        title: "第三方用户ID",
        name: "userId",
        dataIndex: "userId",
        formItem: {
          initialValue:  record.userId,
          rules: [{ required: true, message: '请输入第三方用户ID' }],
        }
      },
      {
        title: "账号",
        name: "userEmail",
        dataIndex: "userEmail",
        formItem: {
          initialValue:  record.userEmail,
          rules: [{ required: true, message: '请输入账号' }],
        }
      },
      {
        title: "密码",
        name: "password",
        dataIndex: "password",
        formItem: {
          initialValue:  record.password,
          rules: [{ required: true, message: '请输入密码' }],
        }
      },
     
      {
        title: '资源帐号类型',
        name: 'type',
        dataIndex: 'type',
        formItem: {
          initialValue:  record.type,
          type: 'select',
          rules: [{ required: true, message: '请选择资源帐号类型' }],
        },
        dict: [
          {code: 1, codeName: '远程评估 '},
          {code: 2, codeName: '直播课堂/远程认证'}
        ]
      },
      {
        title: "状态",
        name: "status",
        dataIndex: "status",
        formItem: {
          initialValue:  record.status,
          type: 'select',
          rules: [{ required: true, message: '请选择用户状态' }],
        },
        dict: [
          {code: 1, codeName: '激活'},
          {code: 0, codeName: '禁用'},
        ]
      },
      {
        title: "账号到期时间",
        name: "expirationTime",
        dataIndex: "expirationTime",
        formItem: {
          initialValue:  record.expirationTime,
          type: 'date',
        }
      },
    ]

    const formProps = {
      key: this.state.timestamp,
      ref: 'form',
      columns,
     // record:{},
      preview: false,
      onSubmit: this._ok,
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 }
      }
    }

    return <WizForm {...formProps} />
  }
}
const mapStateToProps = (state, ownProps) => {
  const { interactLiveResources } = state
  const save = modelUtils.getModelEntity(interactLiveResources, 'interactLiveResources@batchCreateZoomUserResources')
  return {
    save
  }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(Editor)
